import errorHandler from "../../handlers/errorHandler";
import successHandler from "../../handlers/successHandler";
import { deliveryModeService } from "../../services/deliveryMode.service";
import deliveryModeType from './deliveryModeTypes'

/**
 * GetAllCoupons
 *
 */
export const getAllDeliveryModes = (page) => async (dispatch) => {
  try {
    dispatch({
      type: deliveryModeType["LOADING_DELIVERY_MODE"],
      payLoad: true,
    });
    const response = await deliveryModeService.getAllDeliveryModes(page);
    dispatch({
      type: deliveryModeType["LOADING_DELIVERY_MODE"],
      payLoad: false,
    });
    dispatch({
      type: deliveryModeType["GET_ALL_DELIVERY_MODE"],
      payLoad: response,
    });
  } catch (error) {
    dispatch({
      type: deliveryModeType["LOADING_DELIVERY_MODE"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};

/**
 * StoreCoupons
 * @param {object} payLoad{ name:"gaming",types: skilled}
 * @returns {void}
 * */
export const createDeliveryMode = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: deliveryModeType["LOADING_DELIVERY_MODE"], payLoad: true });
    const response = await deliveryModeService.storeDeliveryMode({ ...payLoad });
    dispatch({ type: deliveryModeType["LOADING_DELIVERY_MODE"], payLoad: false });
    dispatch({ type: deliveryModeType["STORE_DELIVERY_MODE"], payLoad: response });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({ type: deliveryModeType["LOADING_DELIVERY_MODE"], payLoad: false });
    errorHandler(error, true);
  }
};

export const editDeliveryMode = (payLoad) => async (dispatch) => {
  try {
    dispatch({ type: deliveryModeType["LOADING_DELIVERY_MODE"], payLoad: true });
    const response = await deliveryModeService.editDeliveryMode({ ...payLoad });
    dispatch({ type: deliveryModeType["LOADING_DELIVERY_MODE"], payLoad: false });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({ type: deliveryModeType["LOADING_DELIVERY_MODE"], payLoad: false });
    errorHandler(error, true);
  }
};

export const createPromoCode = (payLoad) => async (dispatch) => {
  try {
    dispatch({
      type: deliveryModeType["LOADING_DELIVERY_MODE"],
      payLoad: true,
    });
    const response = await deliveryModeService.storeDeliveryMode({
      ...payLoad,
    });
    dispatch({
      type: deliveryModeType["LOADING_DELIVERY_MODE"],
      payLoad: false,
    });
    dispatch({
      type: deliveryModeType["STORE_DELIVERY_MODE"],
      payLoad: response,
    });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({
      type: deliveryModeType["LOADING_DELIVERY_MODE"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};

/**
 * Delete DeliveryMode
 * @param {object} payLoad{ id:"22"}
 * @returns {void}
 * */
export const deleteDeliveryMode = (payLoad) => async (dispatch) => {
  try {
    dispatch({
      type: deliveryModeType["DELETING"],
      payLoad: true,
    });
    const response = await deliveryModeService.deleteDeliveryMode(payLoad);
    dispatch({
      type: deliveryModeType["DELETING"],
      payLoad: false,
    });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({
      type: deliveryModeType["DELETING"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};


/**
 * Edit Coupon
 * @param {object} payLoad {id:"22"}
 * @returns {void}
 * */
export const editCoupon = (payLoad) => async (dispatch) => {
  try {
    const response = await deliveryModeService.editCoupon({
      ...payLoad,
    });

    dispatch({
      type: deliveryModeType["LOADING_DELIVERY_MODE"],
      payLoad: false,
    });
    dispatch({
      type: deliveryModeType["EDIT_PROMO"],
      payLoad: response,
    });
    successHandler(response, true);
    return response;
  } catch (error) {
    dispatch({
      type: deliveryModeType["LOADING_DELIVERY_MODE"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};
/**
 * Edit Coupon
 * @param {object} payLoad {search:"ogwugo"}
 * @returns {void}
 * */
export const searchDeliveryModes = (payLoad) => async (dispatch) => {
  try {
    dispatch({
      type: deliveryModeType["LOADING_SEARCH"],
      payLoad: true,
    });
    const response = await deliveryModeService.searchDeliveryModes({
      ...payLoad,
    });

    dispatch({
      type: deliveryModeType["LOADING_SEARCH"],
      payLoad: false,
    });
    dispatch({
      type: deliveryModeType["SEARCH_DELIVERY_MODE"],
      payLoad: response,
    });
    return response;
  } catch (error) {
    dispatch({
      type: deliveryModeType["LOADING_SEARCH"],
      payLoad: false,
    });
  }
};
/**
 * Edit Coupon
 * @param {object} payLoad {company_id :"7b3e58e0-b68c-498d-b8d5-82198ef6d481"}
 * @returns {void}
 * */
export const filterDeliveryModes = (payLoad, page) => async (dispatch) => {
  try {
    dispatch({
      type: deliveryModeType["FILTERING"],
      payLoad: true,
    });
    const response = await deliveryModeService.filterDeliveryModes({
      ...payLoad,
      page,
    });
    dispatch({
      type: deliveryModeType["FILTERING"],
      payLoad: false,
    });
    dispatch({
      type: deliveryModeType["FILTER_DELIVERY_MODE"],
      payLoad: response,
    });
    return response;
  } catch (error) {
    dispatch({
      type: deliveryModeType["FILTERING"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};
export const filterCouponsNoPage = (payLoad) => async (dispatch) => {
  try {
    dispatch({
      type: deliveryModeType["FILTERING"],
      payLoad: true,
    });
    const response = await deliveryModeService.filterCouponNoPage({
      ...payLoad,
    });
    dispatch({
      type: deliveryModeType["FILTERING"],
      payLoad: false,
    });
    dispatch({
      type: deliveryModeType["FILTER_PROMO_NOPAGE"],
      payLoad: response,
    });
    return response;
  } catch (error) {
    dispatch({
      type: deliveryModeType["FILTERING"],
      payLoad: false,
    });
    errorHandler(error, true);
  }
};
/**
 * Show PromoCode
 * @param {object} payLoad {properties:1}
 * */
export const showPromoCode = (payLoad) => async (dispatch) => {
  try {
    dispatch({
      type: deliveryModeType["LOADING_DELIVERY_MODE"],
      payLoad: true,
    });
    const response = await deliveryModeService.showADeliveryMode(payLoad);

    dispatch({
      type: deliveryModeType["LOADING_DELIVERY_MODE"],
      payLoad: false,
    });
    dispatch({
      type: deliveryModeType["SHOW_DELIVERY_MODE"],
      payLoad: response,
    });
    return response;
  } catch (error) {
    dispatch({
      type: deliveryModeType["LOADING_DELIVERY_MODE"],
      payLoad: false,
    });
    errorHandler(error, true);
    throw new Error("");
  }
};

